import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const CheckoutModal = ({ open, onClose }) => {
    const navigate = useNavigate();

    const handleGuestCheckout = () => {
        onClose();
        navigate("/checkout?guest=true");
    };

    const handleLoginRedirect = () => {
        onClose();
        navigate("/login?redirect=/checkout");
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle><FormattedMessage id="place_order" /></DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    <FormattedMessage id="checkout_choose_mode" />
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={handleLoginRedirect}
                        sx={{
                            backgroundColor: '#000',
                            color: '#fff',
                            '&:hover': { backgroundColor: '#333' }
                        }}
                    >
                        <FormattedMessage id="checkout_login_or_register" />
                    </Button>
                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={handleGuestCheckout}
                        sx={{
                            borderColor: '#000',
                            color: '#000',
                            '&:hover': { borderColor: '#333', backgroundColor: '#f5f5f5' }
                        }}
                    >
                        <FormattedMessage id="checkout_as_guest" />
                    </Button>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} sx={{ color: 'text.primary' }}><FormattedMessage id="cancel" /></Button>
            </DialogActions>
        </Dialog>
    );
};

export default CheckoutModal;
